import { NavLink } from "react-router-dom";
import { products } from "@/data/products";
import { ProductCard } from "@/components/ProductCard";

export function NewArrivals() {
  const newProducts = products.filter((p) => p.badge === "NEW").slice(0, 5);

  if (newProducts.length === 0) return null;

  return (
    <section className="py-10 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-6 md:mb-10">
          <div>
            <p className="text-[10px] sm:text-[11px] tracking-[0.3em] uppercase text-emerald-600 font-semibold mb-2 md:mb-3">
              Appena arrivati
            </p>
            <h2 className="text-xl sm:text-2xl md:text-5xl text-stone-900 font-semibold md:font-bold tracking-tight leading-[1.05]">
              Nuovi arrivi
            </h2>
          </div>
          <NavLink
            to="/shop"
            className="hidden sm:inline-flex text-[10px] tracking-widest uppercase text-stone-500 hover:text-stone-900 transition-colors border-b border-stone-300 hover:border-stone-900 pb-0.5"
          >
            Esplora tutti →
          </NavLink>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-3 md:gap-4">
          {newProducts.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <NavLink
            to="/shop"
            className="text-[10px] tracking-widest uppercase border border-stone-400 text-stone-600 px-8 py-3 hover:bg-stone-900 hover:text-white hover:border-stone-900 transition-colors inline-block"
          >
            Esplora tutti
          </NavLink>
        </div>
      </div>
    </section>
  );
}
